"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import n from "react";
import { useClose as T } from '../../internal/close-provider.js';
import { forwardRefWithAs as p, mergeProps as r } from '../../utils/render.js';
import { Button as s } from '../button/button.js';
let i = "button";
function l(t, e) {
  let o = T();
  return n.createElement(s, _objectSpread({
    ref: e
  }, r({
    onClick: o
  }, t)));
}
let y = p(l);
export { y as CloseButton };